import styled from "styled-components";

export const StyledPropertySelectWrapper = styled.div`
  width: ${({ isCollapsed }) => (isCollapsed ? "40px" : "100%")};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px;
  position: relative;
  transition: 0.3s all ease-in-out;
  &.selectProfile {
    max-width: 200px;
  }
  .textFilter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px;
    margin-bottom: 8px;
    border-radius: 20px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    background: ${({ $icon }) =>
      $icon ? "${({ theme }) => theme?.light?.primary50};" : "transparent"};
    transition: 0.3s all ease-in-out;
    color: rgba(255, 255, 255, 0.75);
    span {
      display: flex;
      gap: 10px;
    }
    &:hover {
      background: rgba(125, 245, 0, 0.15);
      color: #7DF500;
      span {
        img {
          cursor: pointer;
          filter: brightness(0) saturate(100%) invert(65%) sepia(16%)
            saturate(1994%) hue-rotate(101deg) brightness(86%) contrast(81%);
        }
      }
    }
    font {
      &:hover {
        background: none !important;
        box-shadow: none !important;
      }
    }
  }
    .active {
      background: rgba(125, 245, 0, 0.15);
      color: #7DF500;
      span {
        img {
          cursor: pointer;
          filter: brightness(0) saturate(100%) invert(65%) sepia(16%)
            saturate(1994%) hue-rotate(101deg) brightness(86%) contrast(81%);
        }
      }
    }
  .iconWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s all ease-in-out;
    transform: ${({ $icon }) => ($icon ? "scale(-1)" : "scale(1)")};
  }
`;
export const ItemWrapper = styled.ul`
  width: 100%;
  z-index: 2;
  width: 100%;
  padding: ${({ $height }) => ($height ? "10px 0" : "0")};
  max-height: ${({ $height }) => ($height ? "200px" : "0")};
  opacity: ${({ $height }) => ($height ? "1" : "0")};
  visibility: ${({ $height }) => ($height ? "visible" : "hidden")};
  overflow: hidden;
  li {
    position: relative;
    background: transparent !important;
    margin: 0 0 0 35px !important;
    padding: 8px 15px 8px 20px;
    z-index: 2;
    cursor: pointer;
    a {
      color: rgba(255, 255, 255, 0.65);
      transition: all ease-in-out 0.3s;
    }
    &:before {
      content: "";
      position: absolute;
      width: 10px;
      height: 1px;
      background: rgba(255, 255, 255, 0.4);
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all ease-in-out 0.3s;
    }
    &:hover {
      a {
        color: #7DF500;
      }
      &:before {
        background: #7DF500;
      }
    }
    .active {
      color: #7DF500;
      background: transparent;
    }
  }
`;
